<app-floorplan-measurement-line-menu></app-floorplan-measurement-line-menu>
<hr />
<app-floorplan-reference-measure-menu></app-floorplan-reference-measure-menu>
